import { tagColors } from "@/components/tag/tag-colors";
export const inventoryStatusEnum = {
  /**
   * WAIT_CHECK="待盘点"
   */
  WAIT_CHECK: 'waitCheck',
  /**
   * COMPLETED="已完成"
   */
  COMPLETED: 'completed',
  /**
   * ABOLISHED="已作废"
   */
  ABOLISHED: 'abolished'
};

export const inventoryOption = [
  {id: "waitCheck", text: "待盘点", ...tagColors.orange},
  {id: "completed", text: "已完成", ...tagColors.green},
  {id: "abolished", text: "已作废", ...tagColors.lightGray},
];

export const countingResultOption = [
  {id: "surplus", text: "盘盈", ...tagColors.green},
  {id: "deficient", text: "盘亏", ...tagColors.red},
  {id: "flat", text: "盘平", ...tagColors.orange},
];

export const logOpType = [
  {id: 'Add', text: '新增'},
  {id: 'Update', text: '更新'},
  {id: 'Abolish', text: '作废'},
  {id: 'Complete', text: '完成'},
];
